export class SecondaryGuestModel {
    id: number;
    fullName: string;
    documentType: string;
    documentId: string;
    dialingCode: string;
    contactNo: string;
    address: string;
    tempId: number;
    minor: boolean;
    bodyTemperature: number;
    
}
